module.exports = __webpack_public_path__ + "img/skinbox-spring.108ac1a0.png";